
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_1qv14_99",
  "pad-bottom": "awsui_pad-bottom_15o6u_1qv14_123",
  "has-background": "awsui_has-background_15o6u_1qv14_132",
  "highlighted": "awsui_highlighted_15o6u_1qv14_135",
  "selected": "awsui_selected_15o6u_1qv14_135",
  "disabled": "awsui_disabled_15o6u_1qv14_153",
  "next-item-selected": "awsui_next-item-selected_15o6u_1qv14_163",
  "is-keyboard": "awsui_is-keyboard_15o6u_1qv14_175",
  "parent": "awsui_parent_15o6u_1qv14_179",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_1qv14_183",
  "child": "awsui_child_15o6u_1qv14_201",
  "virtual": "awsui_virtual_15o6u_1qv14_216",
  "measure-strut": "awsui_measure-strut_15o6u_1qv14_227",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_1qv14_236",
  "screenreader-content": "awsui_screenreader-content_15o6u_1qv14_240",
  "option-content": "awsui_option-content_15o6u_1qv14_246"
};
  